import { pipe, map, some, equals } from 'lodash/fp';
import {
  SSO_INVITED_REGISTRATION_PATH,
  SSO_CONTACT_REGISTRATION_PATH,
  SSO_ROOT,
} from './constants';

/**
 * Creates a function that executes an array of validator functions against a pathname
 * @param validators Array of validator functions that take a pathname string and return boolean
 * @returns Function that takes a pathname and returns array of validation results
 */
const validatorPipe = (validators: Array<(p: string) => boolean>) => (pathname: string) =>
  map((fn: (p: string) => boolean) => fn(pathname), validators);

/**
 * Global search path for the application
 * Constructed based on the SPA base URL to handle both root and non-root deployments
 * @constant {string}
 */

export const isPortalPathname = (pathname: string) => pathname.startsWith(SSO_ROOT);
export const isPortalRegistrationPathname = (pathname: string) =>
  pathname.startsWith(SSO_CONTACT_REGISTRATION_PATH);
export const isInvitedRegistrationPathname = (pathname: string) =>
  pathname.startsWith(SSO_INVITED_REGISTRATION_PATH);

const GLOBAL_SEARCH_PATH = window.spaBaseUrl !== '/' ? `${window.spaBaseUrl}/search` : '/search';
export const isGlobalSearchPath = (pathname: string) => pathname.startsWith(GLOBAL_SEARCH_PATH);

/**
 * Checks if the current pathname is a protected path that requires authentication
 * @returns {boolean} True if current path requires auth, false otherwise
 */
export const isProtectedPath = (includeSearchPath = false): boolean =>
  pipe(
    validatorPipe([isPortalPathname, ...(includeSearchPath ? [isGlobalSearchPath] : [])]),
    some(equals(true)),
  )(window.location.pathname);
